import { HttpApiEndpoint, HttpApiGroup, HttpApiMiddleware, HttpServerRequest, } from "@effect/platform";
import { Effect, Layer } from "effect";
import { CurrentDearestInternal } from "@pima/domain-data/principal-context";
import * as S from "effect/Schema";
import { DearestEligibilityResponse, DearestSettings, DeleteSharesResult, ExternalSignupEligibilityPayload, } from "./dearest.js";
import { Forbidden } from "./shares.js";
import { Unauthorized } from "./principal.js";
/**
 * Group middleware providing CurrentDearestInternal. apps/api sets the
 * header only on a request that presented `DEAREST_INTERNAL_PIMA_API_KEY`.
 */
export class DearestInternalMiddleware extends HttpApiMiddleware.Tag()("@pima/web-api/DearestInternalMiddleware", {
    provides: CurrentDearestInternal,
    failure: Unauthorized,
}) {
}
/**
 * Internal header the Express bridge sets once the Dearest key matched. Like
 * the principal header, the bridge builds every header of the synthetic
 * Request itself, so an external caller cannot send one.
 */
export const DEAREST_INTERNAL_HEADER = "x-pima-dearest-internal";
const DearestInternalFromJson = S.parseJson(S.Struct({ kind: S.Literal("dearest-internal") }));
export const encodeDearestInternalHeader = S.encodeSync(DearestInternalFromJson);
export const decodeDearestInternalHeader = S.decodeUnknownSync(DearestInternalFromJson);
const unauthorized = { _tag: "Unauthorized" };
/** Admits a request only when the bridge set the Dearest header. */
export const DearestInternalMiddlewareLive = Layer.succeed(DearestInternalMiddleware, Effect.gen(function* () {
    const request = yield* HttpServerRequest.HttpServerRequest;
    const raw = request.headers[DEAREST_INTERNAL_HEADER];
    if (typeof raw !== "string" || raw.length === 0)
        return yield* Effect.fail(unauthorized);
    return yield* S.decodeUnknown(DearestInternalFromJson)(raw).pipe(Effect.mapError(() => unauthorized));
}));
export const GetDearestSettings = HttpApiEndpoint.get("getSettings", "/dearest-internal/settings/:clientId")
    .setPath(S.Struct({ clientId: S.UUID }))
    .addSuccess(S.Struct({ data: DearestSettings }))
    .addError(Forbidden, { status: 403 });
export const DearestSignupEligibility = HttpApiEndpoint.post("externalSignupEligibility", "/dearest-internal/external-signup/eligibility")
    .setPayload(ExternalSignupEligibilityPayload)
    .addSuccess(S.Struct({ data: DearestEligibilityResponse }));
export const DeleteDearestSharesPayload = S.Struct({
    user_ids: S.NonEmptyArray(S.UUID),
});
export const DeleteDearestShares = HttpApiEndpoint.post("deleteShares", "/dearest-internal/shares/delete")
    .setPayload(DeleteDearestSharesPayload)
    .addSuccess(S.Struct({ data: DeleteSharesResult }));
/** What PIMA One serves dearest-api; nothing here is reachable by a session. */
export const dearestInternalGroup = HttpApiGroup.make("dearestInternal")
    .add(GetDearestSettings)
    .add(DearestSignupEligibility)
    .add(DeleteDearestShares)
    .middleware(DearestInternalMiddleware);
//# sourceMappingURL=dearest-internal.js.map